import { NS } from '../U2001';

/** BL-0520 — mappe les codes ssoError du retour Google vers des clés i18n u2001. */
export function u2001MapSsoErrorKey(ssoError: string): string {
  switch (ssoError) {
    case 'ACCOUNT_MISMATCH':
      return 'login.sso.accountMismatch';
    case 'NO_MATCHING_USER':
      return 'login.sso.noMatchingUser';
    case 'PERSONAL_ACCOUNT':
      return 'login.sso.personalAccount';
    case 'EXPIRED_OR_REPLAY':
      return 'login.sso.expired';
    case 'USER_LOCKED':
      return 'msgAccountLocked';
    default:
      return 'msgUnexpectedError';
  }
}

type TranslateFn = (key: string, opts?: Record<string, unknown>) => string;

/** BL-0520 — message d’erreur pour POST /loginMethod (429, 503 BU200101). */
export function u2001MapLoginMethodError(
  error: { status?: number; data?: { errors?: Array<{ errorCode?: string }> } } | null | undefined,
  t: TranslateFn,
): string {
  if (error?.status === 429) {
    return t('login.sso.tooManyAttempts', { ns: NS });
  }
  if (error?.status === 503) {
    const errorList = error?.data?.errors || [];
    const isBu200101 = errorList.some((e) => e.errorCode === 'BU200101');
    if (isBu200101) {
      return t('login.sso.notConfigured', { ns: NS });
    }
  }
  return t('msgUnexpectedError', { ns: NS });
}

export const U2001_SSO_PASSWORD_PATH_DISABLED = 'BU200106';

type SsoPasswordPathError = {
  data?: { errors?: Array<{ errorCode?: string; description?: string }> };
};

/** BL-0523 — message pour BU200106 (chemins mot de passe / MFA local fermés). */
export function u2001MapSsoPasswordPathDisabled(
  error: SsoPasswordPathError | null | undefined,
  t: TranslateFn,
): string | null {
  const match = (error?.data?.errors || []).find(
    (e) => e.errorCode === U2001_SSO_PASSWORD_PATH_DISABLED,
  );
  if (!match) {
    return null;
  }
  const description = match.description?.trim();
  if (description) {
    return description;
  }
  return t('login.sso.passwordPathDisabled', { ns: NS });
}
